import React, { useState } from "react"
import axios from "axios"
import { useAuth } from "../context/AuthContext"
import { useNavigate, redirect, useLocation, Link } from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import PostData from "../services/PostData";
import SnackbarEx from "../components/Helpers/SnackbarEx";
import Bread_Bskt from "../images/Bread_Bskt.png"
import GoogleSignIn from "./GoogleAuth";


function Authorization() {
    const { login: contextLogin } = useAuth();
    const [emailInput, setEmailInput] = useState("")
    const [passInput, setPassInput] = useState("")

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })

    const [load, setLoad] = useState(false)
    const [loggingIn, setLoggingIn] = useState(false)
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const apiLink = 'api/login/analytics'

    const navigate = useNavigate()

    const getRedirectPath = (role) => {
        // Check for redirect param first
        const redirectParam = params.get("redirect");
        if (redirectParam) return redirectParam;

        // Default redirects based on role
        if (role === "GlobalAdmin" || role === "AppAdmin") {
            return "/invoice-file-upload";
        }
        return "/invoice-file-upload";
    };

    /*-----------------------Handle Login--------------------------*/
    /*
    async function handleLogin(event) {
        setLoggingIn(true)
        event.preventDefault()
        try {
            const { success, error: loginError, usr, db, role, token } = await PostData(
                {
                    "email": emailInput,
                    "password": passInput
                }, apiLink, true)
            setLoad(true)

            if (success && (role === "AnalyticsOnly")) {
                // sessionStorage.setItem("urtkn", token)
                setLoad(false)
                setLoggingIn(false)
                login(true, db, usr, role)
                const redirectTo = params.get("redirect") || "/invoice-file-upload";
                navigate(redirectTo, { replace: true });
            }
            else if (success && (role === "GlobalAdmin" || role === "AppAdmin")) {
                setLoad(false)
                setLoggingIn(false)
                login(true, db, usr, role)

                const redirectTo = params.get("redirect") || "/invoice-file-upload";
                navigate(redirectTo, { replace: true });

            } else if (success && (role === "User")) {
                setLoad(false)
                setLoggingIn(false)
                login(true, db, usr, role)
                const redirectTo = params.get("redirect") || "/invoice-file-upload";
                navigate(redirectTo, { replace: true });
            }
            else {
                setLoad(false)
                setLoggingIn(false)
                // setEmailInput("")
                setPassInput("")
                if (loginError) {
                    setOpenTestSnack({ color: "error", message: loginError?.response?.data?.error, open: true })
                }

                redirect("/login")
            }
        } catch (error) {
            console.error(error)
            redirect("/login")
        }
    }

    const handleGoogleSignIn = async (idToken) => {
        setLoad(true)

        const { success, error: loginError, usr, role, db } = await PostData({ "credential": idToken }, "api/login/analytics-google", true)
        console.log('Success:', success, "ROLE : ", role)
        if (success) {
            // sessionStorage.setItem("urtkn", token) // You might want to handle token storage within AuthContext's login
            setLoad(false)
            setLoggingIn(false)
            login(true, db, usr, role)
            const redirectTo = params.get("redirect") || "/invoice-file-upload";
            navigate(redirectTo, { replace: true });
        } else {
            setLoad(false)
            setLoggingIn(false)
            setPassInput("") // Only clear password on error
            if (loginError) {
                setOpenTestSnack({ color: "error", message: loginError?.response?.data?.error, open: true })
            }
            // No need to router.push("/login") as we are already on the login page
        }
    }
        */

    async function handleLogin(event) {
        event.preventDefault()
        setLoggingIn(true)
        try {
            const { success, error: loginError, usr, role } = await PostData(
                {
                    "email": emailInput,
                    "password": passInput
                }, apiLink, true)
            if (!success) {
                const apiMessage =
                    loginError?.response?.data?.error ||
                    loginError?.response?.data?.message ||
                    "Login failed. Check your email and password.";
                throw new Error(apiMessage);
            }
            const loginResult = await contextLogin(usr, role);

            if (loginResult.success) {
                const redirectPath = getRedirectPath(role);
                navigate(redirectPath, { replace: true });
            } else {
                throw new Error(loginResult.error || "Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            setPassInput("");
            setOpenTestSnack({
                color: "error",
                message: error?.message || "An error has occurred.",
                open: true
            });
        } finally {
            setLoggingIn(false);
        }
    }

    const handleGoogleSignIn = async (idToken) => {
        setLoad(true)
        const { success, error: loginError, usr, role, db } = await PostData({ "credential": idToken }, "api/login/analytics-google", true)
        const loginResult = await contextLogin(usr, role);
        if (loginResult.success) {
            const redirectPath = getRedirectPath(role);
            navigate(redirectPath, { replace: true });
        } else {
            throw new Error(loginResult.error || "Login failed");
        }
    }


    /*-----------------------Render--------------------------*/
    if (load) {
        return (<div className="pg-spin" style={{ position: 'relative', top: '50%' }}><CircularProgress /></div>)
    }
    return (
        <>
            <div className="auth-page">
                <div className="auth-page-inner">
                    <div className="auth-brand">
                        <img src={Bread_Bskt} alt="Bread Bskt" className="auth-brand-mark" />
                    </div>

                    <div className="login-container">
                        <p className="login-heading">Welcome Back!</p>
                        <hr className="login-divider" />

                        <form className="login-form" onSubmit={handleLogin}>
                            <div className="login-form-field">
                                <TextField
                                    size="small"
                                    name="email"
                                    type="text"
                                    label="Email"
                                    required
                                    fullWidth
                                    onChange={(e) => setEmailInput(e.target.value)}
                                    value={emailInput}
                                />
                            </div>
                            <div className="login-form-field">
                                <TextField
                                    size="small"
                                    name="password"
                                    type="password"
                                    label="Password"
                                    required
                                    fullWidth
                                    onChange={(e) => setPassInput(e.target.value)}
                                    value={passInput}
                                />
                            </div>

                            <div className="login-form-actions">
                                <button className="submit" type="submit">
                                    {loggingIn ? <CircularProgress size={20} sx={{ color: 'white' }} /> : "Login"}
                                </button>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <GoogleSignIn googCredentials={(googCreds) => handleGoogleSignIn(googCreds)} />
                                </div>
                            </div>
                        </form>

                        <Link to={"/reset-password"} className="login-forgot">
                            Forgot Password?
                        </Link>
                    </div>
                </div>
            </div>
            {
                openTestSnack.open && <SnackbarEx
                    color={openTestSnack.color}
                    position="top"
                    message={openTestSnack.message}
                    open={openTestSnack.open}
                    close={() => setOpenTestSnack({
                        color: "",
                        message: "",
                        open: false
                    })} />
            }
        </>
    )
}

export default Authorization
